import { render, staticRenderFns } from "./about-introduce.vue?vue&type=template&id=334bc7d8&scoped=true&"
import script from "./about-introduce.vue?vue&type=script&lang=js&"
export * from "./about-introduce.vue?vue&type=script&lang=js&"
import style0 from "./about-introduce.vue?vue&type=style&index=0&id=334bc7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334bc7d8",
  null
  
)

export default component.exports